<script>
import gql from 'graphql-tag'
import BaseLayout from '@/components/shared/layout/BaseLayout'
import videoVimeo from '@/components/shared/VideoVimeo'
import platformDetect from '@/mixins/platformDetect'
import { findIndex } from 'lodash-es'
export default {
  name: 'Timeline',
  props: {
  },
  data () {
    return {
      timelines: null,
      valvid: '',
      urlvid: '',
    }
  },
  mixins: [
    platformDetect,
    // getUsagerStatistiques,
  ],
  apollo: {
    timelines: {
      /*eslint-disable*/
      query: gql `query timelines{
        timelines{
          id description titre timeline_containers{
            date date_format hebrew_year id options position container{
              tag_visibles{
                id name
              } categorie_list description id titre medias{
                id image{
                  description titre thumbnail(dimension: "450x")
                } mediable_id mediable_type position video{
                  description link minutage titre url
                }
              }
            }
          }
        }
      }`,
      update: data => data.timelines,
      fetchPolicy: 'cache-first',
      /*eslint-enable*/
      loadingKey: 'loading',
      watchLoading (isLoading, countModifier) {
      // isLoading is a boolean
      // countModifier is either 1 or -1
        // console.log('EN CHARGEMENT', isLoading)
      },
    },
  },
  components: {
    BaseLayout,
    videoVimeo,
  },
  methods: {
    goTo (adresse) {
      this.$router.push({ name: 'info-song-show', params: { id: adresse } })
    },
    triTimeline: function (timeline) {
      var temp = [{annee: '', val: [{}]}]
      var anneetemp = ''
      var index = 1
      var animal = ''
      // console.log(timeline)
      // temp = orderBy(timeline, ['id'], ['asc'])
      // console.log(temp)
      for (var i = 0; i < timeline.length; i++) {
        anneetemp = timeline[i].date.substring(0, 4)
        if (findIndex(temp, {'annee': anneetemp}) === -1) {
          var tab = [timeline[i]]
          /*eslint-disable*/
          if (anneetemp % 12 === 0) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvM3V5MmxkOGF1a19tb25rZXkucG5nIl1d/monkey.png?sha=9dd2f53ae120eabe'
          } else if (anneetemp % 12 === 1) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvOWtzeXhuN2E4c19yb29zdGVyLnBuZyJdXQ/rooster.png?sha=5511fa90e200705e'
          } else if (anneetemp % 12 === 2) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvMjZiNmN1b295dl9kb2cucG5nIl1d/dog.png?sha=8c3fe2d2676a936e'
          } else if (anneetemp % 12 === 3) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvMWpybHBzb3phbl9waWcucG5nIl1d/pig.png?sha=d2018ffc9ac29ce5'
          } else if (anneetemp % 12 === 4) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvMjg0ZXI4OTB2eV9yYXQucG5nIl1d/rat.png?sha=88da06ec324aded1'
          } else if (anneetemp % 12 === 5) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvOWI0ajYzYzhlYl9veC5wbmciXV0/ox.png?sha=331ce008a1c2a23f'
          } else if (anneetemp % 12 === 6) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvN2o1N201M2dmeV90aWdlci5wbmciXV0/tiger.png?sha=22e39f90e66530b3'
          } else if (anneetemp % 12 === 7) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvMjlwNGFhYTR5el9yYWJiaXQucG5nIl1d/rabbit.png?sha=05a1323e7599e1f3'
          } else if (anneetemp % 12 === 8) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvM29zZm1mbWptc19kcmFnb24ucG5nIl1d/dragon.png?sha=37563427c0b427a0'
          } else if (anneetemp % 12 === 9) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvNmt0bGVoNGIzMV9zbmFrZS5wbmciXV0/snake.png?sha=0cf0a4b545130064'
          } else if (anneetemp % 12 === 10) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvNW5iN2ZyaWtpeV9ob3JzZS5wbmciXV0/horse.png?sha=c58a4d6fa56760a2'
          } else {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvNGU1ZGZnbzJ5cF9nb2F0LnBuZyJdXQ/goat.png?sha=5d6091bfea61b6e5'
          }
          /*eslint-enable*/
          temp[index] = {annee: anneetemp, val: tab, zodiac: animal}
          index++
        } else {
          var indice = findIndex(temp, {'annee': anneetemp})
          temp[indice].val.push(timeline[i])
        }
      }
      return temp
    },
  },
}
</script>
<template lang="pug">
base-layout.overflow-x-hidden
  div.imgbackground
  div.timeline.pt5
    q-btn.fixed-bottom-right.animate-pop.z-999(v-back-to-top.animate='{offset: 500, duration: 200}', round='', color='negative', style='margin: 0 30px 30px 0')
      i.fa.fa-caret-up.fa-2x.white
    div(v-if='timelines', v-for='time in timelines')
      //- h1.white {{time.titre}}
      div.titretimeline.ttu
        div.white A timeline of songs and writers
      div.fulldatecontainer(v-if='index > 0', v-for='(details, index) in triTimeline(time.timeline_containers)')
        div.datecontainer
          div.animal
           img(:src='details.zodiac')
          div.date
            span.datenumber {{details.annee}}
        div.secondarydates.white
          span.pr1 Hebraic year
          span.pl1 {{details.val[0].hebrew_year}}
        div.contenutimeline.mb2.mt2.shadow-5
          div(v-for='(info, index) in details.val')
            h1 {{info.container.titre}}
            p(v-html='info.container.description')
            div.pt3(v-for='med in info.container.medias')
              div(v-if="med.mediable_type === 'Image'")
                img(v-if='med.image.thumbnail', :src="med.image.thumbnail", width="90%" height="90%")
                p.descriptionimg(v-html='med.image.description')
                // img(v-else, :src="med.image.thumbnail", width="90%" height="90%")
              div(v-if="med.mediable_type === 'Video'")
                video-vimeo(:med='med')
            div(v-if='info.container.tag_visibles.length > 0')
              q-btn.historybtn.center(@click='goTo(info.container.tag_visibles[0].name)') Read more
            hr.lignestyle(v-if='details.val.length > 1 && index % 2 === 0')
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.historybtn{
  border: solid white 2px!important;
  font-family: Abril Fatface!important;
  text-transform: uppercase!important;
  font-size: 18px;
  width:175px!important;
  color:white!important;
  margin-top: 40px!important;
  background-color: rgba(0,0,0,0.7);
  display: block !important;
  margin:0 auto;
}
/*ANIMATIONS*/

.titretimeline{
  -moz-animation: fadeIn 2s 1s;
  -webkit-animation: fadeIn 2s 1s;
  animation: fadeIn 2s 1s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.fulldatecontainer{
  -moz-animation: fadeIn 2s 2s;
  -webkit-animation: fadeIn 2s 2s;
  animation: fadeIn 2s 2s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}

/*ANIMATIONS END*/

/*mobile*/
.titretimeline{
  color:white;
  font-family:Abril Fatface;
  font-size: 35px;
  padding-bottom: 20px;
  width:75%;
  margin: 0 auto;
}
.lignestyle{
  border-color:white;
  margin:10px 0 10px 0;
  border-style: solid;
}
@media only screen and (min-width: 320px){
  .imgbackground{
  background-image: url("~@/assets/JWWC-SET-6_dark_light.jpg");
  background-size: cover;
  width: 105vw;
  height:105vh;
  position: fixed;
  z-index:-2;
  left:-10px;
  top:-10px;
  }
  .timeline{
    & .datecontainer{
      height:148px;
      width: 250px;
      margin: 0 auto;
      position:relative;
      & .animal{
        position:absolute;
      }
      & .date{
        position:relative;
        top:62%;
        width:250px;
        & .datenumber{
          width:250px;
          font-family: BritannicBold;
          text-align: center;
          color: black;
          font-size:34px;
          z-index:10;
        }
      }
    }
    & .secondarydates{
      /*background-color:red;*/
      width:210px;
      height:40px;
      font-family: BritannicBold;
      font-size:20px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
    }
    & .iframe{
      width: 100%;
    }
    & .pastilleleft{
      background-color:red;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      position: absolute;
      left: 25px;
      /*top: 10px;*/
    }
    & .ligneleft{
      background-color:red;
      /*border-radius: 50%;*/
      width: 3px;
      height: 100vh;
      left: 33px;
      top: 30px;
    }
    & h1{
      /*titre*/
      color:white;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 1);
      font-family:BritannicBold;
      font-size: 24px;
      padding-bottom: 20px;
      margin: 0px !important;
    }
    & p{
      color:white;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 1);
      font-size: 20px;
      line-height: 24px;
      font-family: Crimson Text;
    }
    & p.hyperlinkbtn{
      background-color: red;
      padding: 10px;
      margin: 20px 20px 0 20px;
      border-radius: 6px;
      font-family: BritannicBold;
      color: white;
      & a{
        color:white;
      }
      & a:after{
        font-family: FontAwesome;
        content:"\f08e";
        margin-left: 10px;
      }
    }
    & .contenutimeline{
      /*background-image: url('~@/assets/textures/lightpaperfibers-light.jpg');*/
      width: 80%;
      max-width:800px;
      margin: 20px auto 40px auto;
      padding: 30px 20px 30px 20px;
      text-align: left;
      border: white 2px solid;
      & .boutonnext{
        font-family:BritannicBold;
      }
      & .descriptionimg{
        font-size:10px;
        text-align: center;
        & p{
          font-size:16px;
        }
      }
      & img{
        display:block;
        margin: 20px auto 20px;
      }
      & iframe{
        display:block;
        margin: 0 auto;
      }
    }
  }
}
@media only screen and (min-width: 320px) and (orientation:landscape) {
}


/*TABLET*/

@media only screen and (min-width: 768px){
  .timeline{
    width: 70%;
    margin: 0 auto;
  }
}
@media only screen and (min-width: 768px)and (orientation:landscape) {
  .timeline{
    width: 60%;
    margin: 0 auto;
  }
}
@media only screen and (min-width: 961px){
  .timeline{
  }
}
@media (min-width:320px)  { /* smartphones, iPhone, portrait 480x320 phones */ }
@media (min-width:481px)  { /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */ }
@media (min-width:641px)  { /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */ }
@media (min-width:961px)  { /* tablet, landscape iPad, lo-res laptops ands desktops */ }
@media (min-width:1025px) { /* big landscape tablets, laptops, and desktops */ }
@media (min-width:1281px) { /* hi-res laptops and desktops */ }

</style>



// WEBPACK FOOTER //
// Timeline.vue?1129b216